import React from 'react';
import { useStock } from '../hooks/useInventory';
import { FiltersBar } from '../components/FiltersBar';
import { DataTable } from '../components/DataTable';

const Stock: React.FC = () => {
  const [filters, setFilters] = React.useState<Record<string, string>>({});
  const { data } = useStock(filters);
  return (
    <div className="p-4 space-y-4">
      <div className="flex justify-between items-center"><h1 className="text-xl font-semibold">Stock on-hand</h1></div>
      <FiltersBar onChange={setFilters} defaults={filters} />
      <DataTable title="Stock" data={data ?? []} columns={[{ key: 'itemId', label: 'Ítem' }, { key: 'location', label: 'Ubicación' }, { key: 'onHand', label: 'On-hand' }]} />
    </div>
  );
};

export default Stock;
